{
  "labels": {
    "paste": "Klistra in",
    "pasteAsPlaintext": "Klistra som oformaterad text",
    "pasteCharts": "Klistra in diagram",
    "selectAll": "Markera alla",
    "multiSelect": "Lägg till element till markering",
    "moveCanvas": "Flytta canvas",
    "cut": "Klipp ut",
    "copy": "Kopiera",
    "copyAsPng": "Kopiera till urklipp som PNG",
    "copyAsSvg": "Kopiera till urklipp som SVG",
    "copyText": "Kopiera till urklipp som text",
    "copySource": "Kopiera källa till urklipp",
    "convertToCode": "Konvertera till kod",
    "bringForward": "Flytta framåt",
    "sendToBack": "Flytta underst",
    "bringToFront": "Flytta främst",
    "sendBackward": "Skicka bakåt",
    "delete": "Ta bort",
    "copyStyles": "Kopiera stil",
    "pasteStyles": "Klistra in stil",
    "stroke": "Linje",
    "background": "Bakgrund",
    "fill": "Fyllnad",
    "strokeWidth": "Linjebredd",
    "strokeStyle": "Linjestil",
    "strokeStyle_solid": "Solid",
    "strokeStyle_dashed": "Streckad",
    "strokeStyle_dotted": "Punktad",
    "sloppiness": "Slarvighet",
    "opacity": "Genomskinlighet",
    "textAlign": "Textjustering",
    "edges": "Kanter",
    "sharp": "Skarp",
    "round": "Rund",
    "arrowheads": "Pilhuvuden",
    "arrowhead_none": "Inga",
    "arrowhead_arrow": "Pil",
    "arrowhead_bar": "Stolpe",
    "arrowhead_circle": "Cirkel",
    "arrowhead_circle_outline": "Cirkel (kontur)",
    "arrowhead_triangle": "Triangel",
    "arrowhead_triangle_outline": "Triangel (kontur)",
    "arrowhead_diamond": "Diamant",
    "arrowhead_diamond_outline": "Diamant (kontur)",
    "fontSize": "Teckenstorlek",
    "fontFamily": "Teckensnitt",
    "addWatermark": "Lägg till \"Skapad med Excalidraw\"",
    "handDrawn": "Handritad",
    "normal": "Normal",
    "code": "Kod",
    "small": "Liten",
    "medium": "Medium",
    "large": "Stor",
    "veryLarge": "Mycket stor",
    "solid": "Solid",
    "hachure": "Skraffering",
    "zigzag": "Sicksack",
    "crossHatch": "Skraffera med kors",
    "thin": "Tunn",
    "bold": "Fet",
    "left": "Vänster",
    "center": "Centrera",
    "right": "Höger",
    "extraBold": "Extra fet",
    "architect": "Arkitekt",
    "artist": "Artist",
    "cartoonist": "Serietecknare",
    "fileTitle": "Filnamn",
    "colorPicker": "Färgväljare",
    "canvasColors": "Används på canvas",
    "canvasBackground": "Canvas-bakgrund",
    "drawingCanvas": "Ritar canvas",
    "layers": "Lager",
    "actions": "Åtgärder",
    "language": "Språk",
    "liveCollaboration": "Samarbeta live...",
    "duplicateSelection": "Duplicera",
    "untitled": "Namnlös",
    "name": "Namn",
    "yourName": "Ditt namn",
    "madeWithExcalidraw": "Skapad med Excalidraw",
    "group": "Gruppera markering",
    "ungroup": "Avgruppera markering",
    "collaborators": "Medarbetare",
    "showGrid": "Visa rutnät",
    "addToLibrary": "Lägg till i biblioteket",
    "removeFromLibrary": "Ta bort från bibliotek",
    "libraryLoadingMessage": "Laddar bibliotek…",
    "libraries": "Bläddra i bibliotek",
    "loadingScene": "Laddar skiss…",
    "align": "Justera",
    "alignTop": "Justera överkant",
    "alignBottom": "Justera underkant",
    "alignLeft": "Justera vänster",
    "alignRight": "Justera höger",
    "centerVertically": "Centrera vertikalt",
    "centerHorizontally": "Centrera horisontellt",
    "distributeHorizontally": "Fördela horisontellt",
    "distributeVertically": "Fördela vertikalt",
    "flipHorizontal": "Vänd horisontellt",
    "flipVertical": "Vänd vertikalt",
    "viewMode": "Visningsläge",
    "share": "Dela",
    "showStroke": "Visa färgväljare för linjefärg",
    "showBackground": "Visa färgväljare för bakgrundsfärg",
    "toggleTheme": "Växla tema",
    "personalLib": "Personligt bibliotek",
    "excalidrawLib": "Excalidraw bibliotek",
    "decreaseFontSize": "Minska fontstorleken",
    "increaseFontSize": "Öka fontstorleken",
    "unbindText": "Koppla bort text",
    "bindText": "Bind texten till behållaren",
    "createContainerFromText": "Radbryt text i en avgränsad yta",
    "link": {
      "edit": "Redigera länk",
      "editEmbed": "Redigera länk & bädda in",
      "create": "Skapa länk",
      "createEmbed": "Skapa länk & bädda in",
      "label": "Länk",
      "labelEmbed": "Länka & bädda in",
      "empty": "Ingen länk är angiven"
    },
    "lineEditor": {
      "edit": "Redigera linje",
      "exit": "Avsluta linjeredigerare"
    },
    "elementLock": {
      "lock": "Lås",
      "unlock": "Lås upp",
      "lockAll": "Lås alla",
      "unlockAll": "Lås upp alla"
    },
    "statusPublished": "Publicerad",
    "sidebarLock": "Håll sidofältet öppet",
    "selectAllElementsInFrame": "Markera alla element i rutan",
    "removeAllElementsFromFrame": "Ta bort alla element från rutan",
    "eyeDropper": "Välj färg från canvas",
    "textToDiagram": "Text till diagram",
    "prompt": "Fråga"
  },
  "library": {
    "noItems": "Inga objekt tillagda ännu...",
    "hint_emptyLibrary": "Välj ett objekt på canvasen för att lägga till det här, eller installera ett bibliotek från det publika arkivet, nedan.",
    "hint_emptyPrivateLibrary": "Välj ett objekt på canvasen för att lägga till det här."
  },
  "buttons": {
    "clearReset": "Återställ canvasen",
    "exportJSON": "Exportera till fil",
    "exportImage": "Exportera bild...",
    "export": "Spara till...",
    "copyToClipboard": "Kopiera till urklipp",
    "save": "Spara till aktuell fil",
    "saveAs": "Spara som",
    "load": "Öppna",
    "getShareableLink": "Hämta delbar länk",
    "close": "Stäng",
    "selectLanguage": "Välj språk",
    "scrollBackToContent": "Bläddra tillbaka till innehållet",
    "zoomIn": "Zooma in",
    "zoomOut": "Zooma ut",
    "resetZoom": "Återställ zoom",
    "menu": "Meny",
    "done": "Klart",
    "edit": "Redigera",
    "undo": "Ångra",
    "redo": "Gör om",
    "resetLibrary": "Återställ bibliotek",
    "createNewRoom": "Skapa ett nytt rum",
    "fullScreen": "Helskärm",
    "darkMode": "Mörkt läge",
    "lightMode": "Ljust läge",
    "zenMode": "Zen-läge",
    "objectsSnapMode": "Fäst mot objekt",
    "exitZenMode": "Gå ur zen-läge",
    "cancel": "Avbryt",
    "clear": "Rensa",
    "remove": "Ta bort",
    "embed": "Växla inbäddning",
    "publishLibrary": "Publicera",
    "submit": "Skicka",
    "confirm": "Bekräfta",
    "embeddableInteractionButton": "Klicka för att interagera"
  },
  "alerts": {
    "clearReset": "Detta rensar hela canvasen. Är du säker?",
    "couldNotCreateShareableLink": "Kunde inte skapa delbar länk.",
    "couldNotCreateShareableLinkTooBig": "Kunde inte skapa delbar länk: skissen är för stor",
    "couldNotLoadInvalidFile": "Kunde inte ladda ogiltig fil",
    "importBackendFailed": "Importering från backend misslyckades.",
    "cannotExportEmptyCanvas": "Kan inte exportera tom canvas.",
    "couldNotCopyToClipboard": "Kunde inte kopiera till urklipp.",
    "decryptFailed": "Kunde inte avkryptera data.",
    "uploadedSecurly": "Uppladdning har säkrats med kryptering från ände till ände. vilket innebär att Excalidraw server och tredje part inte kan läsa innehållet.",
    "loadSceneOverridePrompt": "Laddning av extern skiss kommer att ersätta ditt befintliga innehåll. Vill du fortsätta?",
    "collabStopOverridePrompt": "Att stoppa sessionen kommer att skriva över din föregående, lokalt lagrade skiss. Är du säker?\n\n(Om du vill behålla din lokala skiss, stäng bara webbläsarfliken istället.)",
    "errorAddingToLibrary": "Kunde inte lägga till objekt i biblioteket",
    "errorRemovingFromLibrary": "Kunde inte ta bort objekt från biblioteket",
    "confirmAddLibrary": "Detta kommer att lägga till {{numShapes}} form(er) till ditt bibliotek. Är du säker?",
    "imageDoesNotContainScene": "Den här bilden verkar inte innehålla någon skissdata. Har du aktiverat inbäddning av skiss under export?",
    "cannotRestoreFromImage": "Skiss kunde inte återställas från denna bildfil",
    "invalidSceneUrl": "Det gick inte att importera skiss från den angivna webbadressen. Antingen har den fel format, eller så innehåller den ingen giltig Excalidraw JSON data.",
    "resetLibrary": "Detta kommer att rensa ditt bibliotek. Är du säker?",
    "removeItemsFromsLibrary": "Ta bort {{count}} objekt från biblioteket?",
    "invalidEncryptionKey": "Krypteringsnyckeln måste vara 22 tecken. Livesamarbetet är inaktiverat.",
    "collabOfflineWarning": "Ingen internetanslutning tillgänglig.\nDina ändringar kommer inte att sparas!"
  },
  "errors": {
    "unsupportedFileType": "Filtypen stöds inte.",
    "imageInsertError": "Kunde inte infoga bild. Försök igen senare...",
    "fileTooBig": "Filen är för stor. Maximal tillåten storlek är {{maxSize}}.",
    "svgImageInsertError": "Kunde inte infoga SVG-bild. SVG-koden ser ogiltig ut.",
    "failedToFetchImage": "Kunde inte hämta bilden.",
    "invalidSVGString": "Ogiltig SVG.",
    "cannotResolveCollabServer": "Det gick inte att ansluta till samarbets-servern. Ladda om sidan och försök igen.",
    "importLibraryError": "Kunde inte ladda bibliotek",
    "collabSaveFailed": "Det gick inte att spara i backend-databasen. Om problemen kvarstår bör du spara filen lokalt för att se till att du inte förlorar ditt arbete.",
    "collabSaveFailed_sizeExceeded": "Det gick inte att spara till backend-databasen, whiteboarden verkar vara för stor. Du bör spara filen lokalt för att du inte ska förlora ditt arbete.",
    "imageToolNotSupported": "Bilder är inaktiverade.",
    "brave_measure_text_error": {
      "line1": "Det ser ut som om du använder Brave-webbläsaren med <bold>Aggressivt Blockera fingeravtryck</bold> inställningen aktiverad.",
      "line2": "Detta kan resultera i trasiga <bold>Textelement</bold> i dina ritningar.",
      "line3": "Vi rekommenderar starkt att du inaktiverar den här inställningen. Du kan följa <link>dessa steg</link> för att inaktivera den.",
      "line4": "Om inaktivering av denna inställning inte åtgärdar visningen av textelement, öppna ett <issueLink>ärende</issueLink> på vår GitHub, eller skriv till oss på <discordLink>Discord</discordLink>"
    },
    "libraryElementTypeError": {
      "embeddable": "Inbäddbara element kan inte läggas till i biblioteket.",
      "iframe": "IFrame-element kan inte läggas till i biblioteket.",
      "image": "Stöd för att lägga till bilder till biblioteket kommer snart!"
    },
    "asyncPasteFailedOnRead": "Kunde inte klistra in (kunde inte läsa från urklipp).",
    "asyncPasteFailedOnParse": "Kunde inte klistra in.",
    "copyToSystemClipboardFailed": "Kunde inte kopiera till urklipp."
  },
  "toolBar": {
    "selection": "Markering",
    "image": "Infoga bild",
    "rectangle": "Rektangel",
    "diamond": "Diamant",
    "ellipse": "Ellips",
    "arrow": "Pil",
    "line": "Linje",
    "freedraw": "Rita",
    "text": "Text",
    "library": "Bibliotek",
    "lock": "Håll valt verktyg aktivt efter ritande",
    "penMode": "Pennläge - förhindra touch",
    "link": "Lägg till / Uppdatera länk för en vald form",
    "eraser": "Radergummi",
    "frame": "Rutverktyg",
    "magicframe": "Trådram till kod",
    "embeddable": "Bädda in (web)",
    "laser": "Laserpekare",
    "hand": "Hand (panoreringsverktyg)",
    "extraTools": "Fler verktyg",
    "mermaidToExcalidraw": "Mermaid till Excalidraw",
    "magicSettings": "AI-inställningar"
  },
  "headings": {
    "canvasActions": "Canvas-åtgärder",
    "selectedShapeActions": "Valda formåtgärder",
    "shapes": "Former"
  },
  "hints": {
    "canvasPanning": "För att flytta whiteboarden, håll mushjulet eller mellanslagstangenten medan du drar eller använd handverktyget",
    "linearElement": "Klicka för att starta flera punkter, dra för en linje",
    "freeDraw": "Klicka och dra, släpp när du är klar",
    "text": "Tips: du kan också lägga till text genom att dubbelklicka var som helst med markeringsverktyget",
    "embeddable": "Klicka-dra för att skapa en webbplats-inbäddning",
    "text_selected": "Dubbelklicka eller tryck ENTER för att redigera text",
    "text_editing": "Tryck Escape eller CtrlOrCmd + ENTER för att slutföra redigeringen",
    "linearElementMulti": "Klicka på sista punkten eller tryck Escape eller Enter för att avsluta",
    "lockAngle": "Du kan begränsa vinkeln genom att hålla SKIFT",
    "resize": "Du kan behålla proportioner genom att hålla SHIFT medan du ändrar storlek,\nhåller du ALT ändras storlek relativt mitten",
    "resizeImage": "Du kan ändra storlek fritt genom att hålla SHIFT,\nhåll ALT för att ändra storlek från mitten",
    "rotate": "Du kan begränsa vinklar genom att hålla SHIFT medan du roterar",
    "lineEditor_info": "Håll Ctrl/Cmd och dubbelklicka eller tryck på Ctrl/Cmd + Enter för att redigera punkter",
    "lineEditor_pointSelected": "Tryck på Ta bort för att ta bort punkt(er), Ctrl + D eller Cmd + D för att duplicera, eller dra för att flytta",
    "lineEditor_nothingSelected": "Välj en punkt att redigera (håll SHIFT för att välja flera),\neller håll ned Alt och klicka för att lägga till nya punkter",
    "placeImage": "Klicka för att placera bilden, eller klicka och dra för att ställa in dess storlek manuellt",
    "publishLibrary": "Publicera ditt eget bibliotek",
    "bindTextToElement": "Tryck på Enter för att lägga till text",
    "deepBoxSelect": "Håll Ctrl eller Cmd för att djupvälja, och för att förhindra att dra",
    "eraserRevert": "Håll Alt för att återställa de element som är markerade för borttagning",
    "firefox_clipboard_write": "Denna funktion kan sannolikt aktiveras genom att ställa in \"dom.events.asyncClipboard.clipboardItem\" flaggan till \"true\". För att ändra webbläsarens flaggor i Firefox, besök \"about:config\" sidan.",
    "disableSnapping": "Håll Ctrl eller Cmd för att inaktivera fästning"
  },
  "canvasError": {
    "cannotShowPreview": "Kan inte visa förhandsgranskning",
    "canvasTooBig": "Canvasen kan vara för stor.",
    "canvasTooBigTip": "Tips: prova att flytta de mest avlägsna elementen lite närmare varandra."
  },
  "errorSplash": {
    "headingMain": "Ett fel uppstod. Försök <button>med att läsa in sidan på nytt.</button>",
    "clearCanvasMessage": "Om omladdning inte fungerar, försök <button>rensa canvasen.</button>",
    "clearCanvasCaveat": " Detta kommer att leda till förlust av arbete ",
    "trackedToSentry": "Felet med identifieraren {{eventId}} spårades på vårt system.",
    "openIssueMessage": "Vi var mycket försiktiga med att inte inkludera din skissinformation om felet. Om din skiss inte är privat, vänligen överväga att följa upp på vår <button>buggspårare.</button> Vänligen inkludera information nedan genom att kopiera och klistra in i GitHub-problemet.",
    "sceneContent": "Skissinnehåll:"
  },
  "roomDialog": {
    "desc_intro": "Du kan bjuda in personer till din nuvarande skiss för att samarbeta med dig.",
    "desc_privacy": "Oroa dig inte, sessionen använder kryptering från ände till ände, så vad du än ritar kommer att förbli privat. Inte ens vår server kommer att kunna se vad du skissar.",
    "button_startSession": "Starta sessionen",
    "button_stopSession": "Stoppa session",
    "desc_inProgressIntro": "Nu pågår en live-samarbetssession.",
    "desc_shareLink": "Dela denna länk med någon du vill samarbeta med:",
    "desc_exitSession": "Att avbryta sessionen kommer att koppla bort dig från rummet, men du kommer att kunna fortsätta arbeta med skissen, lokalt. Observera att detta inte påverkar andra människor, och de kommer fortfarande att kunna samarbeta på deras version.",
    "shareTitle": "Delta i en live-samarbetssession på Excalidraw"
  },
  "errorDialog": {
    "title": "Fel"
  },
  "exportDialog": {
    "disk_title": "Spara till disk",
    "disk_details": "Exportera skissdata till en fil som du kan importera från senare.",
    "disk_button": "Spara till fil",
    "link_title": "Delbar länk",
    "link_details": "Exportera som en skrivskyddad länk.",
    "link_button": "Exportera till länk",
    "excalidrawplus_description": "Spara skissen till din Excalidraw+ arbetsyta.",
    "excalidrawplus_button": "Exportera",
    "excalidrawplus_exportError": "Det gick inte att exportera till Excalidraw+ just nu..."
  },
  "helpDialog": {
    "blog": "Läs vår blogg",
    "click": "klicka",
    "deepSelect": "Djupval",
    "deepBoxSelect": "Djupval inom boxen, och förhindra att dra",
    "curvedArrow": "Böjd pil",
    "curvedLine": "Böjd linje",
    "documentation": "Dokumentation",
    "doubleClick": "dubbelklicka",
    "drag": "dra",
    "editor": "Redigerare",
    "editLineArrowPoints": "Redigera linje-/pilpunkter",
    "editText": "Redigera text / lägg till etikett",
    "github": "Hittat ett problem? Rapportera",
    "howto": "Följ våra guider",
    "or": "eller",
    "preventBinding": "Förhindra pilbindning",
    "tools": "Verktyg",
    "shortcuts": "Tangentbordsgenvägar",
    "textFinish": "Slutför redigering (text)",
    "textNewLine": "Lägg till ny rad (text)",
    "title": "Hjälp",
    "view": "Visa",
    "zoomToFit": "Zooma för att rymma alla element",
    "zoomToSelection": "Zooma till markering",
    "toggleElementLock": "Lås/Lås upp valda",
    "movePageUpDown": "Flytta sida upp/ner",
    "movePageLeftRight": "Flytta sida vänster/höger"
  },
  "clearCanvasDialog": {
    "title": "Rensa canvas"
  },
  "publishDialog": {
    "title": "Publicera bibliotek",
    "itemName": "Objektnamn",
    "authorName": "Upphovsmannens namn",
    "githubUsername": "GitHub-användarnamn",
    "twitterUsername": "Twitter-användarnamn",
    "libraryName": "Biblioteksnamn",
    "libraryDesc": "Biblioteksbeskrivning",
    "website": "Webbplats",
    "placeholder": {
      "authorName": "Ditt namn eller användarnamn",
      "libraryName": "Namn på ditt bibliotek",
      "libraryDesc": "Beskrivning av ditt bibliotek för att hjälpa människor att förstå dess användning",
      "githubHandle": "Github-användarnamn (valfritt), så att du kan redigera biblioteket när du har skickat in det för granskning",
      "twitterHandle": "Twitter-användarnamn (valfritt), så vi vet vem att kreditera när du marknadsför på Twitter",
      "website": "Länk till din personliga webbplats eller någon annan (valfritt)"
    },
    "errors": {
      "required": "Obligatoriskt",
      "website": "Ange en giltig URL"
    },
    "noteDescription": "Skicka ditt bibliotek för att inkluderas i <link>det offentliga bibliotekets arkiv</link>för andra människor att använda i sina skisser.",
    "noteGuidelines": "Biblioteket måste godkännas manuellt först. Vänligen läs <link>riktlinjerna</link> innan du skickar in. Du behöver ett GitHub-konto för att kommunicera och göra ändringar om så önskas, men det krävs inte.",
    "noteLicense": "Genom att skicka in godkänner du att biblioteket kommer att publiceras under <link>MIT-licens, </link>vilket kort sagt betyder att vem som helst kan använda det utan restriktioner.",
    "noteItems": "Varje objekt måste ha sitt eget namn så att det är filtrerbart. Följande objekt kommer att inkluderas:",
    "atleastOneLibItem": "Välj minst ett biblioteksobjekt för att komma igång",
    "republishWarning": "Obs: några av de markerade objekten är redan markerade som publicerade/skickade. Du bör endast skicka objekt igen när du uppdaterar ett befintligt bibliotek eller inlämning."
  },
  "publishSuccessDialog": {
    "title": "Bibliotek inskickat",
    "content": "Tack {{authorName}}. Ditt bibliotek har skickats för granskning. Du kan följa status<link>här</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Återställ bibliotek",
    "removeItemsFromLib": "Ta bort markerade objekt från biblioteket"
  },
  "imageExportDialog": {
    "header": "Exportera bild",
    "label": {
      "withBackground": "Bakgrund",
      "onlySelected": "Endast markerade",
      "darkMode": "Mörkt läge",
      "embedScene": "Bädda in skiss",
      "scale": "Skala",
      "padding": "Utfyllnad"
    },
    "tooltip": {
      "embedScene": "Skissdata kommer att sparas i den exporterade PNG/SVG-filen så att skissen kan återställas från den.\nKommer att öka exporterad filstorlek."
    },
    "title": {
      "exportToPng": "Exportera till PNG",
      "exportToSvg": "Exportera till SVG",
      "copyPngToClipboard": "Kopiera PNG till urklipp"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Kopiera till urklipp"
    }
  },
  "encrypted": {
    "tooltip": "Dina skisser är krypterade från ände till ände så Excalidraws servrar kommer aldrig att se dem.",
    "link": "Blogginlägg om kryptering från ände till ände i Excalidraw"
  },
  "stats": {
    "angle": "Vinkel",
    "element": "Element",
    "elements": "Element",
    "height": "Höjd",
    "scene": "Skiss",
    "selected": "Valda",
    "storage": "Lagring",
    "title": "Statistik för nördar",
    "total": "Totalt",
    "version": "Version",
    "versionCopy": "Klicka för att kopiera",
    "versionNotAvailable": "Versionen är inte tillgänglig",
    "width": "Bredd"
  },
  "toast": {
    "addedToLibrary": "Tillagd i biblioteket",
    "copyStyles": "Kopierade stilar.",
    "copyToClipboard": "Kopierad till urklipp.",
    "copyToClipboardAsPng": "Kopierade {{exportSelection}} till urklipp som PNG\n({{exportColorScheme}})",
    "fileSaved": "Fil sparad.",
    "fileSavedToFilename": "Sparad till {filename}",
    "canvas": "canvas",
    "selection": "markering",
    "pasteAsSingleElement": "Använd {{shortcut}} för att klistra in som ett enda element,\neller klistra in i en befintlig textredigerare",
    "unableToEmbed": "Att bädda in denna webbadress är för närvarande inte tillåtet. Skapa en problemrapport på GitHub för att begära att webbadressen vitlistas.",
    "unrecognizedLinkFormat": "Länken du bäddade in matchar inte det förväntade formatet. Försök klistra in 'embed'-strängen som tillhandahålls av källwebbplatsen"
  },
  "colors": {
    "transparent": "Genomskinlig",
    "black": "Svart",
    "white": "Vit",
    "red": "Röd",
    "pink": "Rosa",
    "grape": "Lila",
    "violet": "Violett",
    "gray": "Grå",
    "blue": "Blå",
    "cyan": "Turkos",
    "teal": "Blågrön",
    "green": "Grön",
    "yellow": "Gul",
    "orange": "Orange",
    "bronze": "Brons"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "All data sparas lokalt i din webbläsare.",
      "center_heading_plus": "Ville du gå till Excalidraw+ istället?",
      "menuHint": "Exportera, inställningar, språk, ..."
    },
    "defaults": {
      "menuHint": "Exportera, inställningar och mer...",
      "center_heading": "Förenklade. Diagram.",
      "toolbarHint": "Välj ett verktyg & börja rita!",
      "helpHint": "Genvägar & hjälp"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "Mest frekvent använda anpassade färger",
    "colors": "Färger",
    "shades": "Nyanser",
    "hexCode": "Hex-kod",
    "noShades": "Inga nyanser tillgängliga för denna färg"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Exportera som bild",
        "button": "Exportera som bild",
        "description": "Exportera scendata som en bild från vilken du kan importera senare."
      },
      "saveToDisk": {
        "title": "Spara till disk",
        "button": "Spara till disk",
        "description": "Exportera scendata till en fil från vilken du kan importera senare."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Exportera till Excalidraw+",
        "description": "Spara skissen till din Excalidraw+ arbetsyta."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Läs in från fil",
        "button": "Läs in från fil",
        "description": "Laddar från en fil kommer <bold>ersätta ditt befintliga innehåll</bold>.<br></br>Du kan säkerhetskopiera din ritning först med hjälp av ett av alternativen nedan."
      },
      "shareableLink": {
        "title": "Läs in från länk",
        "button": "Ersätt mitt innehåll",
        "description": "Inläsning av en extern ritning kommer <bold>ersätta ditt befintliga innehåll</bold>.<br></br>Du kan säkerhetskopiera din ritning först genom att använda ett av alternativen nedan."
      }
    }
  },
  "mermaid": {
    "title": "Mermaid till Excalidraw",
    "button": "Infoga",
    "description": "För närvarande stöds endast <flowchartLink>Flödesdiagram</flowchartLink>,<sequenceLink> Sekvensdiagram </sequenceLink> och <classLink>Klassdiagram</classLink>. De andra typerna kommer att återges som bild i Excalidraw.",
    "syntax": "Mermaid-syntax",
    "preview": "Förhandsgranska"
  }
}
